export enum DistanceUnitEnum {
  KM = 'km',
  MI = 'mi'
}
